<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-assignment`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 45h32a2 2 0 002-2V6a2 2 0 00-2-2h-8v4h6v26h-6a1 1 0 00-1 1v6H10V8h18V4H8a2 2 0 00-2 2v37a2 2 0 002 2zm7-30a1 1 0 00-1 1v2a1 1 0 001 1h18a1 1 0 001-1v-2a1 1 0 00-1-1H15zm-1 11a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconAssignment',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
